import { action } from '../constants/constant.action';
const {
  SET_USER_DETAIL, IS_PROFILE_UPDATE
} = action;

export default function reducer(state = {
  user: null
}, action) {
  switch (action.type) {

    case SET_USER_DETAIL:
      return {
        ...state,
        user: action.user
      };

    case IS_PROFILE_UPDATE:
      return {
        ...state,
        isProfileUpdate: action.isProfileUpdate
      };
    default:
      return state;
  }
  // return state;
}